var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeriLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 17,
    viewBox: "0 0 11 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.51411 4.87176C7.49892 4.84009 7.4837 4.80844 7.46851 4.77674C7.46946 4.72674 7.50094 4.69528 7.53772 4.63266C7.5742 4.73889 7.55905 4.80687 7.51411 4.87176Z",
    fill: "#93BC84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.523395 16.8897C0.846543 16.0286 1.22595 15.1921 1.61625 14.3605C1.9604 13.6274 2.31843 12.9008 2.71119 12.1928C3.58086 10.6253 4.3119 8.9905 5.04631 7.35698C5.4358 6.49068 5.8231 5.62324 6.25449 4.77681C6.33995 4.77426 6.32015 4.82298 6.30008 4.87183C6.16598 5.58353 5.98107 6.28285 5.78435 6.97885C5.11737 9.33855 4.23536 11.6105 3.03829 13.7519C2.5671 14.5949 2.051 15.4085 1.42057 16.1422C1.15761 16.4482 0.888251 16.7498 0.535174 16.9578C0.511892 16.9385 0.507942 16.9158 0.523395 16.8897Z",
    fill: "#D1E38D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.483 12.0215C4.4688 12.031 4.45458 12.0405 4.44038 12.05C4.40764 12.0107 4.41041 11.9682 4.42886 11.9241C4.59739 11.4381 4.80928 10.97 5.01613 10.5001C5.54348 9.30212 6.12437 8.13073 6.75266 6.9832C7.53473 5.55476 8.18942 4.06453 8.85602 2.58009C9.21005 1.79172 9.56673 1.0046 9.945 0.227631C9.98241 0.150779 10.0239 0.0759172 10.0635 0.000118974C10.1492 -0.00271351 10.1321 0.0454858 10.1105 0.0960257C9.99117 0.755199 9.82063 1.40211 9.64276 2.04684C9.00299 4.36568 8.14984 6.59913 6.99411 8.70964C6.49269 9.6253 5.94073 10.508 5.25556 11.2986C5.03705 11.5508 4.81124 11.7971 4.53131 11.9844C4.51678 11.9988 4.50061 12.0111 4.483 12.0215Z",
    fill: "#D1E38D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.38465 15.9954C2.73041 15.3953 3.12313 14.826 3.51359 14.2555C4.11532 13.3763 4.7438 12.5167 5.40218 11.6796C6.47946 10.3099 7.43917 8.85618 8.417 7.41526C8.89263 6.7144 9.35998 6.00759 9.87035 5.3313C9.95553 5.32849 9.95107 5.3733 9.92249 5.43093C9.63844 6.1557 9.30324 6.85696 8.95341 7.55101C7.82922 9.78151 6.50839 11.8835 4.90812 13.8013C4.33999 14.4822 3.7384 15.1311 3.05625 15.6992C2.87789 15.8478 2.70027 15.9988 2.49275 16.1071C2.47281 16.1166 2.4562 16.1312 2.43822 16.1437C2.43025 16.1546 2.41953 16.1604 2.40612 16.1609C2.32191 16.1641 2.31118 16.1236 2.3452 16.0567L2.34559 16.056C2.36381 16.0392 2.38031 16.0213 2.38465 15.9954Z",
    fill: "#D1E38D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.64272 11.9236C5.64656 11.9656 5.65042 12.0075 5.65425 12.0495C5.64653 12.0741 5.62706 12.0814 5.60438 12.0841C5.58384 12.0667 5.57959 12.0458 5.59165 12.0216C5.60171 11.9853 5.60806 11.947 5.64272 11.9236Z",
    fill: "#A7C88B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5917 12.0221C5.59595 12.0429 5.60019 12.0638 5.60444 12.0846C5.59621 12.1005 5.57997 12.1065 5.5714 12.0927C5.55404 12.0647 5.56601 12.0402 5.5917 12.0221Z",
    fill: "#68976F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.69702 12.0219C5.7131 12.0095 5.72922 11.9972 5.74533 11.9848C5.73747 12.0081 5.7227 12.0222 5.69702 12.0219Z",
    fill: "#A7C88B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeriLogo);
export default __webpack_public_path__ + "static/media/meri-logo.ede3e344.svg";
export { ForwardRef as ReactComponent };